var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import JSONAPIAdapter from "@ember-data/adapter/json-api";
import ApplicationInstance from "@ember/application/instance";
import { getOwner } from "@ember/owner";
import RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import SemeiaSessionService from "core/services/session";
let CoreAdapter = (_class = class CoreAdapter extends JSONAPIAdapter {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
  }
  get namespace() {
    return "api/v1";
  }
  get headers() {
    const headers = {};
    if (this.session.access_token || this.session.isAuthenticated) {
      headers["Authorization"] = `Bearer ${this.session.access_token || this.session.data.authenticated.access_token}`;
      let authenticated_as;
      if (this.session.patient) {
        authenticated_as = `Patient-${this.session.patient.id}/${this.session.patient.uuid}`;
      } else if (this.session.medic) {
        authenticated_as = `Medic-${this.session.medic.id}/${this.session.medic.uuid}`;
      }
      if (authenticated_as) {
        headers["X-Authenticated-As"] = authenticated_as;
      }
    }
    headers["X-Frontend-Version"] = getOwner(this).resolveRegistration("config:environment").APP.version;
    return headers;
  }

  // Only here while the RT feature is being tested. Will be removed then
  handleResponse(_status, _headers, payload) {
    // This error is returned when the RT feature flag is updated
    // i.e. activated or deactivated, in both case, the user is
    // logged out so that he has to connect again to get the correct
    // AT (and optionally a RT)
    if (payload?.error == "Old access token") {
      if (this.session.medic) {
        return this.router.transitionTo("medics-web.login");
      }
      if (this.session.patient) {
        return this.router.transitionTo("patient-web.login");
      }
    }
    return payload;
  }
  pathForType(modelName) {
    // Configuration models are accessible through the /api/v1/configuration route.
    if (modelName.startsWith("configuration")) {
      return "configurations";
    }
    return super.pathForType(modelName);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CoreAdapter as default };